import type { ReactNode } from 'react'
import { ArrowIcon, Card, Heading } from '@autoplan/web-ui'

type Priority = 'high' | 'medium' | 'low'

type TaskCardProps = {
  icon: ReactNode
  title: string
  subtitle?: ReactNode
  priority?: Priority
  onClick?: () => void
  className?: string
}

const priorityConfig: Record<Priority, { label: string; color: string; dot: string }> = {
  high: {
    label: 'HØY PRIORITERING',
    color: 'ap:text-content-danger',
    dot: 'ap:bg-surface-danger-dark ap:animate-[subtlePulse_2.5s_ease-in-out_infinite]',
  },
  medium: { label: 'STARTET', color: 'ap:text-content-warning', dot: 'ap:bg-surface-warning-dark' },
  low: { label: 'LAV PRIORITERING', color: 'ap:text-accent', dot: 'ap:bg-accent' },
}

export const TaskCard = ({ icon, title, subtitle, priority, onClick, className }: TaskCardProps) => {
  const priorityItem = priority ? priorityConfig[priority] : null

  return (
    <div className="ap:flex ap:min-w-[280px] ap:flex-col ap:snap-start ap:xl:min-w-0 ap:xl:flex-1">
      <Card
        onClick={onClick}
        className={`ap:flex ap:h-full ap:flex-1 ap:min-w-0 ap:flex-col ap:gap-sm ap:p-2xl ${className ?? ''}`}
      >
        <div className="ap:flex ap:items-start ap:justify-between">
          <span className="ap:text-content-secondary">{icon}</span>
          <span className="ap:text-accent">
            <ArrowIcon />
          </span>
        </div>
        <Heading size="md">{title}</Heading>
        {subtitle && <p className="ap:text-sm ap:text-content-secondary">{subtitle}</p>}
        {priorityItem && (
          <div className="ap:mt-auto ap:flex ap:items-center ap:gap-xs ap:pt-sm ap:text-nowrap ap:text-xs ap:text-content-secondary">
            <span className={`ap:flex ap:items-center ap:gap-xs ap:font-semibold ${priorityItem.color}`}>
              <span className={`ap:size-sm ap:rounded-full ${priorityItem.dot}`} />
              {priorityItem.label}
            </span>
          </div>
        )}
      </Card>
    </div>
  )
}
